export default __webpack_public_path__ + "static/headerBg-552f037a0018192f40837c7e40002cb5.png";